"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _palette = require("./palette");

var _palette2 = _interopRequireDefault(_palette);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const messages = {
  default: {
    backgroundColor: _palette2.default.ink["100"],
    color: _palette2.default.ink["900"],
    borderColor: _palette2.default.ink["100"]
  },
  orange: {
    backgroundColor: _palette2.default.orange["000"],
    color: _palette2.default.orange["900"],
    borderColor: _palette2.default.orange["000"]
  },
  red: {
    backgroundColor: _palette2.default.red["000"],
    color: _palette2.default.red["900"],
    borderColor: _palette2.default.red["000"]
  },
  green: {
    backgroundColor: _palette2.default.green["000"],
    color: _palette2.default.green["900"],
    borderColor: _palette2.default.green["000"]
  },
  blue: {
    backgroundColor: _palette2.default.blue["000"],
    color: _palette2.default.blue["900"],
    borderColor: _palette2.default.blue["000"]
  }
};

exports.default = messages;